import { defineComponent as e } from "vue";
import { useRDialog as t } from "./composables/useRDialog.js";
const a = e({
  name: "RDialog",
  setup() {
    const { isDialogVisible: i, setIsDialogVisible: s } = t();
    return { isDialogVisible: i, setIsDialogVisible: s };
  },
  render() {
    return this.$slots.default ? this.$slots.default({
      isDialogVisible: this.isDialogVisible,
      setIsDialogVisible: this.setIsDialogVisible
    }) : null;
  }
});
export {
  a as _
};
